module.exports = "/images/new-pet.png?7d191bb19b97dcfe4cc1f37a5c513269";